/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ErrorCodeDto
 */
export interface ErrorCodeDto {
    /**
     * 
     * @type {string}
     * @memberof ErrorCodeDto
     */
    errorKey?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ErrorCodeDto
     */
    message?: string | null;
}

export function ErrorCodeDtoFromJSON(json: any): ErrorCodeDto {
    return ErrorCodeDtoFromJSONTyped(json, false);
}

export function ErrorCodeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ErrorCodeDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'errorKey': !exists(json, 'errorKey') ? undefined : json['errorKey'],
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function ErrorCodeDtoToJSON(value?: ErrorCodeDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'errorKey': value.errorKey,
        'message': value.message,
    };
}


